import { ConfigProvider, Flex, Tabs } from "antd";

import { CalendarOutlined, CopyOutlined } from "@ant-design/icons";
import cx from "classnames";
import { useTranslation } from "react-i18next";
import { createUseStyles } from 'react-jss';
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";



// const ATTENDANCE_SETTING_MENU = [
//     getItem(
//         "workin_location",
//         "Working Location",
//         "working",
//         <CopyOutlined style={{ color: "gray" }} />
//     ),
//     getItem(
//         "holiday",
//         "Holiday Calendar",
//         "holiday",
//         <CalendarOutlined style={{ color: "gray" }} />
//     ),
//     getItem(
//         "leave_type",
//         "Leave Type",
//         "leave",
//         <CopyOutlined style={{ color: "gray" }} />
//     ),
//     getItem(
//         "shift",
//         "Shifts",
//         "shifts",
//         <CopyOutlined style={{ color: "gray" }} />
//     ),
//     getItem(
//         "workflow",
//         "Work Flow",
//         "workFlow",
//         <CopyOutlined style={{ color: "gray" }} />
//     ),
// ];


const PayrollTabMenu = ({ selectedKeys, menuList = [], className = "", onChange = () => { }, handleMenuChange = () => { }, isCard = false, defalut = null, backgroundColor = '#2151b6', color = 'white' }) => {

    const onMenuClick = (e) => {
        const key = e;
        onChange(key);
        // storage.sessionStorage.setItem("config.menu", key);
    };

    const localtion = useLocation()
    console.log("localtion", localtion);


    const { t } = useTranslation();
    const { roles } = useSelector((state) => state.company);
    function getItem(rules, label, key, icons) {
        let list = [...roles]
        if (!list.includes(rules)) {
            return {}
        }
        return {
            label: label,
            key: key,
            icons: icons
        };
    }
    const MENU = [
        getItem("ACCESS_CONFIGURATION|PAYROLL_SETTING|EMPLOYMENT_TYPE", t('payroll.employment_type_setup.header'), "employment-type-setup", <CopyOutlined style={{ color: "gray" }} />),
        getItem("ACCESS_CONFIGURATION|PAYROLL_SETTING|INCOME", t('income.header'), "income", <CalendarOutlined style={{ color: "gray" }} />),
        getItem("ACCESS_CONFIGURATION|PAYROLL_SETTING|DEDUCTION", t('deduction.header'), "deduction", <CopyOutlined style={{ color: "gray" }} />),
        getItem("ACCESS_CONFIGURATION|PAYROLL_SETTING|WELFARE", t('welfare.header'), "welfare", <CopyOutlined style={{ color: "gray" }} />),
        getItem("ACCESS_CONFIGURATION|PAYROLL_SETTING|FUND", t('fund.header'), "fund", <CopyOutlined style={{ color: "gray" }} />),
    ];


    const useStyles2 = createUseStyles({
        tab: {
            '& .ant-tabs-tab': {
                textAlign: 'center',
                padding: '12px 16px',
                borderRadius: '10rem',
                // margin: '5px',
                fontWeight: 'bold', // Applied to all .ant-tabs .ant-tabs-tab
                background: 'transparent', // Applied to all .ant-tabs .ant-tabs-tab
            },
            '& .ant-tabs-tab.ant-tabs-tab-active': {
                fontWeight: 'bold',
                color: 'white !important',
                background: `${backgroundColor} !important`,
                margin: '5px',
            },
            '& .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-left::before': {
                opacity: '0 !important',
            },
            '& .ant-tabs-nav': {
                margin: '0',
            },
            '& .ant-tabs-nav::before': {
                display: 'none !important',
            },
        },
    });

    const classes = useStyles2();

    return (

        <ConfigProvider theme={{
            components: {
                Tabs: {
                    itemHoverColor: "var(--tab-color)",
                    itemActiveColor: "var(--tab-color)"
                },
            },
        }}>
            <Tabs activeKey={selectedKeys} onChange={onMenuClick} items={MENU?.filter(o => o.key != null)?.map((entity) => {
                return {
                    ...entity,
                    label: <Flex gap={5} style={{
                    }}>
                        {/* {entity.icons} */}
                        {entity.label}
                    </Flex>
                };
            })}>
            </Tabs>
        </ConfigProvider>
    );
};

export default PayrollTabMenu;
